import React from 'react';
import { IFormError } from './FormError.d';

const FormError = ({ message }: IFormError) => (
  <span className="jg-form-error-copy jg-display-b" role="alert">
    {message}
  </span>
);

export default FormError;
